export default "__VITE_ASSET__99PH8F1H__"